import 'react';
import { css } from 'styled-components';
import styledTheming from '../node_modules/styled-theming/index.js';
import '../App.css.js';

/*** GENERICS  ***/

var backgroundColor = styledTheming.variants("layout", "baseColor", {
  pureColor: {
    light: "background-color: var(--light-gray-8);",
    dark: "background-color: var(--dark-gray-8);"
  },
  grey: {
    light: "background-color: var(--white);",
    dark: "background-color: var(--black);"
  }
});
var backgroundHoverSelect = styledTheming("layout", {
  light: "background-color: var(--light-gray-7) !important;",
  dark: "background-color: var(--dark-gray-7) !important;"
});
var color = styledTheming.variants("layout", "color", {
  normal: {
    light: "color: var(--light-gray-9) !important;",
    dark: "color: var(--white) !important;"
  }
});
var colorPlaceholderSelect = styledTheming.variants("layout", "color", {
  normal: {
    light: "color: var(--light-gray-1) !important;",
    dark: "color: var(--dark-gray-1) !important;"
  }
});
styledTheming.variants("layout", "color", {
  normal: {
    light: "border-color: var(--light-gray-9) !important;",
    dark: "border-color: var(--white) !important;"
  }
});
styledTheming.variants("layout", "color", {
  normal: {
    light: "background-color: var(--light-gray-9) !important;",
    dark: "background-color: var(--white) !important;"
  }
});
styledTheming.variants("layout", "border", {
  none: {
    light: "border: none;",
    dark: "border: none;"
  }
});
styledTheming.variants("layout", "borderRadius", {
  normal: {
    light: "border-radius: 16px;",
    dark: "border-radius: 16px;"
  }
});
styledTheming.variants("layout", "padding", {
  normal: {
    light: "",
    dark: ""
  }
});
var placeholderColor = styledTheming("layout", {
  light: css(["color:var(--light-gray-2) !important;"]),
  dark: css(["color:var(--dark-gray-2) !important;"])
});
var colorTextErrors = styledTheming.variants("layout", "hasErrors", {
  true: {
    light: css(["color:var(--red-300) !important;"]),
    dark: css(["color:var(--red-300) !important;"])
  },
  false: {
    light: css(["color:var(--light-gray-9) !important;"]),
    dark: css(["color:var(--white) !important;"])
  }
});
styledTheming("layout", {
  light: css(["filter:brightness(0) invert(0.064);"]),
  dark: css(["filter:brightness(0) invert(0.936);"])
});
var errorStyle = styledTheming("layout", {
  light: css(["background-color:transparent !important;"]),
  dark: css(["background-color:transparent !important;"])
});
var errorStyleFocus = styledTheming.variants("layout", "hasErrors", {
  true: {
    light: css(["background-color:var(--red-300) !important;"]),
    dark: css(["background-color:var(--red-300) !important;"])
  },
  false: {
    light: css(["background-color:var(--light-gray-9) !important;"]),
    dark: css(["background-color:var(--white) !important;"])
  }
});
styledTheming.variants("layout", "hasFocus", {
  true: {
    light: css(["box-shadow:none;background-color:var(--white) !important;border:1px solid var(--green) !important;"]),
    dark: css(["box-shadow:none;background-color:var(--white) !important;border:1px solid var(--green) !important;"])
  },
  false: {
    light: "",
    dark: ""
  }
});
var addonStartStyle = styledTheming.variants("layout", "hasAddonStart", {
  true: {
    light: css(["border-top-left-radius:0;border-bottom-left-radius:0;"]),
    dark: css(["border-top-left-radius:0;border-bottom-left-radius:0;"])
  },
  false: {
    light: "",
    dark: ""
  }
});
var addonEndStyle = styledTheming.variants("layout", "hasAddonEnd", {
  true: {
    light: css(["border-top-right-radius:0;border-bottom-right-radius:0;"]),
    dark: css(["border-top-right-radius:0;border-bottom-right-radius:0;"])
  },
  false: {
    light: "",
    dark: ""
  }
});
export { addonEndStyle, addonStartStyle, backgroundColor, backgroundHoverSelect, color, colorPlaceholderSelect, colorTextErrors, errorStyle, errorStyleFocus, placeholderColor };